export default [
  {
    field: "invitationEmail",
    method: "isEmpty",
    validWhen: false,
    message: ""
  }
];
